import { render, staticRenderFns } from "./organization-detail.vue?vue&type=template&id=4c6feaee&"
import script from "./organization-detail.vue?vue&type=script&lang=js&"
export * from "./organization-detail.vue?vue&type=script&lang=js&"
import style0 from "./organization-detail.vue?vue&type=style&index=0&id=4c6feaee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports